<template>
  <form
    id="quantificationScopesForm"
    class="md-layout"
    @submit.prevent="submitQuantification"
  >
    <h3 class="text-gray">Presupuestado</h3>
    <div class="md-layout-item md-size-100 md-layout">
      <md-field
        class="md-layout-item md-size-20 md-small-size-33 md-xsmall-size-50"
        :class="validationClass('scope')"
      >
        <label> Alcance en días</label>
        <md-input
          v-validate="'required'"
          data-vv-name="scope"
          v-model="plannedScope.scope"
          type="number"
          min="0"
          :disabled="true"
        ></md-input>
      </md-field>

      <md-field
        class="md-layout-item md-size-20 md-small-size-33 md-xsmall-size-50"
        :class="validationClass('masters')"
      >
        <label> Maestros necesarios </label>
        <md-input
          v-validate="'required'"
          data-vv-name="masters"
          v-model="plannedScope.masters"
          type="number"
          min="0"
          :disabled="true"
        ></md-input>
      </md-field>

      <md-field
        class="md-layout-item md-size-20 md-small-size-33 md-xsmall-size-50"
        :class="validationClass('officials')"
      >
        <label> Oficiales necesarios </label>
        <md-input
          v-validate="'required'"
          data-vv-name="officials"
          v-model="plannedScope.officials"
          type="number"
          min="0"
          :disabled="true"
        ></md-input>
      </md-field>

      <md-field
        class="md-layout-item md-size-20 md-small-size-33 md-xsmall-size-50"
        :class="validationClass('assistants')"
      >
        <label> Ayudantes necesarios </label>
        <md-input
          v-validate="'required'"
          data-vv-name="assistants"
          v-model="plannedScope.assistants"
          type="number"
          min="0"
          :disabled="true"
        ></md-input>
      </md-field>

      <md-field
        class="md-layout-item md-size-20 md-small-size-33 md-xsmall-size-50"
        :class="validationClass('flagWorkers')"
      >
        <label> Bandereros necesarios </label>
        <md-input
          v-validate="'required'"
          data-vv-name="flagWorkers"
          v-model="plannedScope.flagWorkers"
          type="number"
          min="0"
          :disabled="true"
        ></md-input>
      </md-field>
    </div>

    <h3>Real</h3>
    <div class="md-layout-item md-size-100 md-layout">
      <md-field
        class="md-layout-item md-size-20 md-small-size-33 md-xsmall-size-50"
        :class="validationClass('scope')"
      >
        <label> Alcance en días </label>
        <md-input
          v-validate="'required'"
          data-vv-name="scope"
          v-model="value.workedDays"
          type="number"
          min="0"
          :disabled="readOnly"
        ></md-input>
      </md-field>

      <md-field
        class="md-layout-item md-size-20 md-small-size-33 md-xsmall-size-50"
        :class="validationClass('masters')"
      >
        <label> Maestros necesarios </label>
        <md-input
          v-validate="'required'"
          data-vv-name="masters"
          v-model="value.avegareMWorkers"
          type="number"
          min="0"
          :disabled="readOnly"
        ></md-input>
      </md-field>

      <md-field
        class="md-layout-item md-size-20 md-small-size-33 md-xsmall-size-50"
        :class="validationClass('officials')"
      >
        <label> Oficiales necesarios </label>
        <md-input
          v-validate="'required'"
          data-vv-name="officials"
          v-model="value.avegareOWorkers"
          type="number"
          min="0"
          :disabled="readOnly"
        ></md-input>
      </md-field>

      <md-field
        class="md-layout-item md-size-20 md-small-size-33 md-xsmall-size-50"
        :class="validationClass('assistants')"
      >
        <label> Ayudantes necesarios </label>
        <md-input
          v-validate="'required'"
          data-vv-name="assistants"
          v-model="value.avegareAWorkers"
          type="number"
          min="0"
          :disabled="readOnly"
        ></md-input>
      </md-field>

      <md-field
        class="md-layout-item md-size-20 md-small-size-33 md-xsmall-size-50"
        :class="validationClass('flagWorkers')"
      >
        <label> Bandereros necesarios </label>
        <md-input
          v-validate="'required'"
          data-vv-name="flagWorkers"
          v-model="value.avegareFWorkers"
          type="number"
          min="0"
          :disabled="readOnly"
        ></md-input>
      </md-field>
    </div>

    <slot></slot>
  </form>
</template>

<script>
export default {
  name: "QuantificationScopes",
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
    plannedScope: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    submitQuantification() {
      this.$emit("submit");
    },
  },
  mounted() {
    this.watchTouched({
      value: ["scope", "masters", "officials", "assistants", "flagWorkers"],
    });
  },
  // watch: {
  //   value: {
  //     deep: true,
  //     handler(value) {
  //       this.$emit("update:realScope", value);
  //     },
  //   },
  // },
};
</script>



// WEBPACK FOOTER //
// src/pages/WorkPlan/WeeklyExecution/QuantificationScopes.vue